<template>
  <div class="zuiminmenu between">
    <div class="menucontent">
      <div class="meliti">刑法罪名库</div>
      <div class="menulist flex_start wrap">
        <div
          class="menuitem ellipsis"
          v-for="(item, index) in zuimlist"
          :key="index"
          @click="tojump(item)"
        >
          {{ item.cat_name }}
        </div>
      </div>
    </div>
    <div class="banner">
      <img src="../../../assets/jpcol/zuiminbanner_sample.png" alt="" />
    </div>
    <div class="kszx">
      <div class="kszt1">有刑事问题马上问律师</div>
      <div class="kszt2">15,604</div>
      <div class="kszt3">位在线律师</div>
      <div class="kszt4btn">立即咨询</div>
      <div class="kszt5">3分钟快速获得律师解答</div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    zuimlist: [],
  }),
  beforeMount() {
    this.getzuiminmenu();
  },
  methods: {
    getzuiminmenu() {
      this.$http.jpcol.getzuiminify().then((res) => {
        this.zuimlist = res.data;
      });
    },
    tojump(item) {
      console.log("跳转了item");
      this.$router.push({
        path: "/jpcol/zuiminlist",
        query:{
          colid:item.id
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.zuiminmenu {
  width: 1200px;
  margin: 0 auto;
  padding: 30px 0;
  align-items: flex-start;
  position: relative;
  padding-left: 220px;
  .menucontent {
    width: 200px;
    height: 400px;
    background: #ffffff;
    padding: 10px 20px;
    box-shadow: 0px 2px 10px 0px rgba(1, 1, 1, 0.1);
    position: absolute;
    top: 30px;
    left: 0;
    overflow: hidden;
    &:hover {
      width: 980px;
      .menulist .menuitem {
        padding-right: 0;
      }
    }
    .meliti {
      font-size: 18px;
      color: #333;
    }
    .menulist {
      width: 940px;
      margin-top: 12px;
      font-size: 14px;
      .menuitem {
        cursor: pointer;
        line-height: 38px;
        width: 30%;
        padding-right: 130px;
        text-align: left;

        &:hover {
          color: #0465ea;
        }
      }
    }
  }
  .banner {
    width: 760px;
    height: 400px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .kszx {
    width: 200px;
    height: 400px;
    background: url("../../../assets/jpcol/zuiminljzx_bg.png") no-repeat;
    box-shadow: 0px 2px 10px 0px rgba(1, 1, 1, 0.1);
    color: #333333;
    text-align: center;
    .kszt1 {
      font-size: 16px;
      line-height: 16px;
      margin-top: 75px;
    }
    .kszt2 {
      font-size: 36px;
      font-weight: bold;
      margin-top: 30px;
    }
    .kszt3 {
      font-size: 18px;
      color: #333333;
    }
    .kszt4btn {
      width: 150px;
      height: 28px;
      line-height: 28px;
      background: #ff7e00;
      cursor: pointer;
      border-radius: 14px;
      font-size: 16px;
      color: #ffffff;
      margin: 70px auto 0;
    }
    .kszt5 {
      margin-top: 18px;
      font-size: 12px;
      color: #333333;
    }
  }
}
</style>